// CTA butonlarinin dil cozumu. Panelde her dil dolu olmayabiliyor:
// locale -> site varsayilani -> ilk dolu dil.

function resolveCTAButtons(welcomeCTA, locale, customerClientDefault) {
    if (!welcomeCTA || !welcomeCTA.enabled) return [];
    const content = welcomeCTA.languageContent || [];
    const pick = (code) => content.find((x) => x.languageCode === code && (x.buttons || []).length);
    const entry = pick(locale) || pick(customerClientDefault) || content.find((x) => (x.buttons || []).length);
    if (!entry) return [];
    return (entry.buttons || []).map((b) => (b && b.text ? String(b.text).trim() : "")).filter(Boolean);
}

module.exports = { resolveCTAButtons };



// WEBPACK FOOTER //
// ./src/utils/welcomeCTA.js